<div class="section-page">
    <div class="section-header-bar">
        <div class="section-header">
            <div class="section-header__actions">
                <button mat-flat-button color="primary" (click)="createRequest()" [disabled]="isLoading">
                    <mat-icon>note_add</mat-icon>
                    Create request
                </button>
                <button mat-stroked-button color="primary" (click)="refreshDocuments()" [disabled]="isLoading">
                    <mat-icon>refresh</mat-icon>
                    Refresh
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading" class="generating-preview">
        <mat-spinner diameter="30" color="primary"></mat-spinner>
        <p class="loading-text">Loading Pandadoc documents...</p>
    </div>
    <div *ngIf="!isLoading && hasError" class="empty-state">
        <mat-icon class="empty-state__icon">cloud_off</mat-icon>
        <p class="empty-state__text">{{ errorMessage || 'Failed to load documents' }}</p>
    </div>
    <div *ngIf="!isLoading && !hasError && !pandadoc_documents.length" class="empty-state">
        <mat-icon class="empty-state__icon">inbox</mat-icon>
        <p class="empty-state__text">No files on Pandadoc</p>
    </div>

    <table *ngIf="showTable" style="overflow: auto;" mat-table [dataSource]="pandadoc_documents" class="flat-table mat-elevation-z0">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Document Name </th>
            <td mat-cell *matCellDef="let doc" style="text-align: justify;">
                <a target="_blank" href="https://app.pandadoc.com/a/#/documents/{{ doc.id }}" style="color: rgb(21, 118, 209); text-decoration: none;">{{ doc?.name | uppercase }}</a>
            </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let doc" style="text-align: justify;">
                <span [ngClass]="doc?.status === 'document.completed' ? 'completed' : ['document.declined', 'document.voided', 'document.rejected'].includes(doc?.status) ? 'failed' : 'black'">{{ doc?.status?.replace('document.', '')?.replaceAll('_', ' ') | uppercase }}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="dateCreated">
            <th mat-header-cell *matHeaderCellDef> Created </th>
            <td mat-cell *matCellDef="let doc" style="text-align: justify;">
                <span>{{ doc?.date_created | date : 'dd-MM-yyyy' }}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="dateModified">
            <th mat-header-cell *matHeaderCellDef> Modified </th>
            <td mat-cell *matCellDef="let doc" style="text-align: justify;">
                <span>{{ doc?.date_modified | date : 'dd-MM-yyyy' }}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="preview">
            <th mat-header-cell *matHeaderCellDef> View </th>
            <td mat-cell *matCellDef="let doc">
                <button mat-icon-button color="primary" (click)="openPreview(doc)" matTooltip="View PDF" aria-label="View PDF">
                    <mat-icon>visibility</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableHeaders"></tr>
        <tr mat-row *matRowDef="let row; columns: tableHeaders"></tr>
    </table>
</div>
